exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".IA_syncPanel_1PKQxRaR_5SSV2fN-A9rav {\n  padding: 0 40px;\n}", ""]);

// Exports
exports.locals = {
	"IA_syncPanel": "IA_syncPanel_1PKQxRaR_5SSV2fN-A9rav"
};